import type React from 'react';
import { useInitCoreAppState } from '../hooks/init';
import { useEffectOnce } from 'common-ui';
import { useAddToCartCustomEvent } from '../hooks/actions/cart/useCartCustomEvents';

export interface AppInitProps {
  children?: React.ReactNode;
}

export const AppInit = ({ children }: AppInitProps) => {
  const initCoreAppState = useInitCoreAppState();
  const addToCartCustomEvent = useAddToCartCustomEvent();

  useEffectOnce(() => {
    initCoreAppState();
    document.addEventListener('aws-add-to-cart', addToCartCustomEvent);
    return () => {
      document.removeEventListener('aws-add-to-cart', addToCartCustomEvent);
    };
  });
  return (children ?? null) as React.ReactElement;
};
